module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/livorno.f73b980d5226f41f3aeb232c76e87ae0.jpg";